import Programs from '../../components/consultants/dashboard/Programs'
import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'

if(document.getElementById('consultants-dashboard')){
    const app = createApp({
        components: {
            Programs
        },
    });
    app.use(BootstrapVueNext);
    app.mount('#consultants-dashboard');

    // manage tabs and appropriate filters
    document.getElementById("connectedOptions").style.display = "block";
    document.getElementById("invitedOptions").style.display = "none";
    var connectedTab = document.getElementById("connected-programs-tab");
    connectedTab.addEventListener('click', function (event) {  
        document.getElementById("connectedOptions").style.display = "block";
        document.getElementById("invitedOptions").style.display = "none";
    }, false);

    var invitedTab = document.getElementById("invited-programs-tab");
    invitedTab.addEventListener('click', function (event) {
        document.getElementById("connectedOptions").style.display = "none";
        document.getElementById("invitedOptions").style.display = "block";
    }, false);

}


